import { Component, OnInit, Inject, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar, MatDialog, getMatFormFieldDuplicatedHintError } from "@angular/material";
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { ClipBoardService } from '../../../services/clipboard.service';
import { ServerService } from '../../../services/server.service';
import { DatePipe } from '@angular/common';
import { AddLeadDeliveredComponent } from '../add-lead-delivered/add-lead-delivered.component';
import { ClipBoardService as messageService } from "src/app/services/clipboard.service";

@Component({
  selector: 'app-raise-escalation',
  templateUrl: './raise-escalation.component.html',
  styleUrls: ['./raise-escalation.component.scss']
})
export class RaiseEscalationComponent implements OnInit {

  authToken = localStorage.getItem("token");

  showComponentLoader: boolean = false;

  btnStatus: boolean = false

  myDateRangePickerOptions = {
    dateFormat: 'dd.mm.yyyy'
  };

  addForm: FormGroup;

  getEscalationCategory: any;

  currentDate: any = new Date();

  campaignData: any;

  clientFeedbackTobeUpload: any=[];

  mmList: any;

  savedFiles:any;
  btnValue: string;
  header: string;
  temp_attach:any;
  
  constructor(
    private serverService: ServerService,
    private clipBoardService: ClipBoardService,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private changeDetectorRef: ChangeDetectorRef,
    private dialog: MatDialog,
    private datePipe: DatePipe,
    private dialogRef: MatDialogRef<AddLeadDeliveredComponent>,
    private clipBoardMessageService: messageService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.currentDate = new Date().toISOString().slice(0, 16); 
    this.campaignData = data
    // console.log(this.data)
    
  }

  ngOnInit() {
    if(this.campaignData.previous_value != undefined){
      this.editDeliveryForm();
      this.btnValue = 'Save';
      this.header = 'Edit Escalation';
    }
    else{
      this.setDeliveryForm();
      this.btnValue = 'Raise Escalation'
      this.header = 'Raise Escalation';
    }
   
    this.getCommon()
    this.getMM()
  }

  getCommon() {

    this.showComponentLoader = true;

    //let url = "campaign_module/campaign/spent_budget_delivery_stats/"+this.data.id;
    let url = "campaign_module/get_common_details"

    this.serverService.getEscalationCategory(url, this.authToken).subscribe(data => {
      // console.log(data)
      this.getEscalationCategory = data.escalation_category_list
      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }

  getMM() {

    this.showComponentLoader = true

    let url = "/campaign_module/user_list";
    this.serverService.getMM(url, this.authToken).subscribe(data => {
      this.mmList = data.data
      //console.log(this.mmList)
      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )

  }

  selectFile(event: any): any {

    if (!event.target.files.length) {
      return false
    }

    //console.log(event.target.files)
    
    let attachNote = Array.from(event.target.files);
    this.temp_attach = attachNote
    const MAX_FILE_SIZE = 100 * 1024 * 1024; 
    this.temp_attach.forEach(element => {
      // console.log(element)
      if (element.size > MAX_FILE_SIZE) {
        // Show error message and skip this file
        this.clipBoardMessageService.showMessgeInText(
          `File "${element.name}" exceeds the maximum allowed size of 100MB.`,
          'error-snackbar'
        );
        return;
      }
      element["ext"] = element["name"].split('.')[1];
      this.clientFeedbackTobeUpload.push(element)
    })
    document.getElementById("uploadFeedbackFile")["value"] = ""
    // console.log(this.clientFeedbackTobeUpload)
  }

  setDeliveryForm() {
    this.addForm = this.fb.group({
      escalationCategory: ['', Validators.compose([Validators.required])],
      marketingManager: [null, Validators.compose([Validators.required])],
      priority: ['Low', Validators.compose([Validators.required])],
      issueDescription: [null, Validators.compose([Validators.required])],
      impact: [null, Validators.compose([Validators.required])],
      supportingLinks: [''],
      supportingFiles: [null],
      deadline: [null, Validators.compose([Validators.required])],
      cc:[]
    
    })
  }
  editDeliveryForm() {
    this.addForm = this.fb.group({
      escalationCategory: [this.campaignData.previous_value.escalation_category, Validators.compose([Validators.required])],
      marketingManager: [this.campaignData.previous_value.assigned_to_id, Validators.compose([Validators.required])],
      priority: [this.campaignData.previous_value.priority, Validators.compose([Validators.required])],
      issueDescription: [this.campaignData.previous_value.issue_description, Validators.compose([Validators.required])],
      impact: [this.campaignData.previous_value.impact, Validators.compose([Validators.required])],
      supportingLinks: [null],
      supportingFiles: [null],
      deadline: [this.campaignData.previous_value.deadline, Validators.compose([Validators.required])],
      cc:[]
    })
    const selectedIds = this.campaignData.previous_value.cc_user_ids.split(',').map(id => parseInt(id, 10));
    this.addForm.get('cc').setValue(selectedIds);
    this.savedFiles = this.campaignData.previous_value.supporting_files;
    let temp = this.campaignData.previous_value.supporting_links.join(",");
    this.addForm.get('supportingLinks').setValue(temp);
    const deadlineWithoutTimezone = this.campaignData.previous_value.deadline.split('+')[0];
    
    // Set the deadline value into the form control
    this.addForm.get('deadline').setValue(deadlineWithoutTimezone);
    // console.log(temp);
  }
  saveEscalationForm() {

    this.showComponentLoader = true;

    this.btnStatus = true;

    const formData: FormData = new FormData();

    formData.append('campaign_id', this.campaignData.id);
    formData.append('escalation_category', this.addForm.value.escalationCategory);
    formData.append('assigned_to_id', this.addForm.value.marketingManager);
    formData.append('priority', this.addForm.value.priority);
    formData.append('issue_description', this.addForm.value.issueDescription);
    formData.append('impact', this.addForm.value.impact);
    if(this.addForm.value.cc){
      formData.append('cc_user_ids', this.addForm.value.cc);
    }
    if (this.clientFeedbackTobeUpload) {
      for (let i = 0; i < this.clientFeedbackTobeUpload.length; i++) {
        let ToUpload = this.clientFeedbackTobeUpload[i];
        formData.append('supporting_files[]', ToUpload);
      }
    }

    formData.append('deadline', this.addForm.value.deadline);
    // console.log(this.addForm.value.supportingLinks)
    if(this.addForm.value.supportingLinks.trim() != ''){
      let temp =  this.addForm.value.supportingLinks.split(",");
  
      temp.forEach((item)=>{
        return  formData.append('supporting_links[]', item.trim())
      })
    }
    else{
      //  formData.append('supporting_links[]',"")
    }

    // formData.append('supporting_links[]', this.addForm.value.supportingLinks);
    // return;
    // console.log(this.addForm.value.marketingManager)
    // return;
  if(this.campaignData.previous_value != undefined){
    this.serverService.put('campaign_module/escalation/'+this.campaignData.previous_value.id, formData, this.authToken).subscribe(data => {
      // this.snackBar.open("Escalation Updated Successfully", '', {
      //   duration: 1000,
      //   verticalPosition: 'top',
      //   horizontalPosition: 'end',
      //   panelClass: 'blue-snackbar'
      // })
      this.clipBoardMessageService.showMessgeInText(
        "Escalation Updated Successfully",
        "success-snackbar"
      );
      this.btnStatus = false
      this.showComponentLoader = false;
      this.dialogRef.close(data)
    },
      err => {
        this.btnStatus = false
        this.showComponentLoader = false;
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }
  else{

  
    this.serverService.raiseEscalationForm('campaign_module/escalation', formData, this.authToken).subscribe(data => {
      // this.snackBar.open("Escalation Raise Successfully", '', {
      //   duration: 1000,
      //   verticalPosition: 'top',
      //   horizontalPosition: 'end',
      //   panelClass: 'blue-snackbar'
      // })
      this.clipBoardMessageService.showMessgeInText(
        "Escalation Raise Successfully",
        "success-snackbar"
      );
      this.btnStatus = false
      this.showComponentLoader = false;
      this.dialogRef.close(data)
    },
      err => {
        this.btnStatus = false
        this.showComponentLoader = false;
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }
  }

  close() {
    this.dialogRef.close();
  }

  onKeyPress(event: KeyboardEvent) {
    const allowedCharacters = /[0-9\+]/;
    const inputChar = String.fromCharCode(event.keyCode);

    if (!allowedCharacters.test(inputChar)) {
      event.preventDefault();
    }
  }
  disableDate(){
    return false;
  }
  userType(item) {
    return item.org_admin && !item.role
      ? 'Vendor Admin'
      : !item.org_admin && !item.role
      ? 'Vendor Standard User'
      : item.role;
  }
  discard(index:any,event:any){
  
      this.clientFeedbackTobeUpload.splice(index, 1);
      // this.creativePreviewUrls.splice(index, 1);
    
  }
}
